module.exports = __webpack_public_path__ + "static/media/node-logo.f546a896.png";